import {
  Box,
  Button,
  Card,
  Drawer,
  IconButton,
  Typography
} from '@mui/material';
import { useCartState } from './CartContext';
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined';
import { Link } from 'react-router-dom';
import Close from '@mui/icons-material/Close';
import { DrawerProductCard } from './DrawerProductCard';
import { EmptyCart } from 'supplier-portals/uxbeauty/pages/SampleCart/EmptyCart';
import { UXB_ROUTE_NAMES } from 'supplier-portals/uxbeauty/UXBRouteNames';
export const CartDrawer = () => {
  const { value, drawerOpen, setDrawerOpen } = useCartState();
  const emptyCart = !value.items.length;

  return (
    <Drawer
      open={drawerOpen}
      anchor={'right'}
      onClose={() => setDrawerOpen(false)}
      sx={{ height: '100vh' }}
    >
      <Box
        sx={{
          maxWidth: 420,
          display: 'grid',
          gridTemplateRows: 'auto 1fr auto',
          height: '100vh'
        }}
      >
        <Box
          sx={theme => ({
            backgroundColor: theme.palette.secondary.light,
            padding: 3,
            display: 'flex',
            justifyContent: 'space-between'
          })}
        >
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <ShoppingCartOutlined />
            <Typography variant="h4">Sample cart</Typography>
          </Box>
          <IconButton
            color="primary"
            size="small"
            onClick={() => setDrawerOpen(false)}
          >
            <Close />
          </IconButton>
        </Box>
        {emptyCart ? (
          <EmptyCart />
        ) : (
          <>
            <Box sx={{ padding: 3, pr: 0, overflowY: 'hidden' }}>
              <Typography>Products selected:</Typography>
              <Box
                sx={{
                  overflowY: 'auto',
                  height: '100%',
                  mt: 1,
                  pb: 2,
                  pr: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1
                }}
              >
                {value.items.map(product => (
                  <DrawerProductCard key={product.old_key} product={product} />
                ))}
              </Box>
            </Box>
            <Card
              variant="outlined"
              sx={{ display: 'flex', flexDirection: 'column', p: 3, gap: 2 }}
            >
              <Typography>
                Go to the summary to add and review details or continue
                exploring to finish later.
              </Typography>
              <Button
                component={Link}
                to={UXB_ROUTE_NAMES.cart}
                onClick={() => setDrawerOpen(false)}
                variant="contained"
              >
                Finalize sample request
              </Button>
              <Button variant="outlined" onClick={() => setDrawerOpen(false)}>
                Continue exploring
              </Button>
            </Card>
          </>
        )}
      </Box>
    </Drawer>
  );
};
